import { Hit, ProductModel } from "../store/ProductStore"
import { NormalizedPromotion, PromotionResponse } from "../store/PromotionStore"
import { transformHit } from "../components/algolia/util/transformHit"

export interface filteredProductsIdProps {
  promotion: PromotionResponse | NormalizedPromotion | null,
  productsIds: string[] | null
  selectedPriceDayOffset: number | null
  selectedRegion: number
  productsById: Record<string, ProductModel>
  selectedStoreId?: string
}

/**
 * Returns an array of product IDs filtered by availability
 * 
 * @param {filteredProductsIdProps} filterData - array of products to be filtered
 * @returns {string[]} array of filtered items
 */
export const filteredProductsIds = (filterData: filteredProductsIdProps) => {
  const { productsIds, selectedPriceDayOffset, selectedRegion, productsById, selectedStoreId } = filterData
  if (!productsIds) return []
  return productsIds.filter(id => {
    const product = productsById[id]
    const transformedHit = product ? transformHit(product as unknown as Hit, selectedPriceDayOffset || 0, selectedStoreId || '0', selectedRegion || 0) as Hit : null

    return product && !(
      !transformedHit?.availableForDayAtStore
      || transformedHit?.isAddToCartDisabled === true
    )
  })
}

/**
 * Returns boolean as to whether there are enough available products within each promotion group
 * 
 * @param {filteredProductsIdProps} filterData - array of products to be filtered
 * @returns {boolean} enough products in each group
 */
export const enoughProductsInPromotionGroup = (filterData: filteredProductsIdProps) => {
  const { promotion, productsById } = filterData
  return promotion?.groups?.every(group => {
    const enabledProductsCount = filteredProductsIds({...filterData, productsIds: group.ids }).filter(id => {
      const product = productsById[id]
      return product && !product.isAddToCartDisabled
    }).length
    return enabledProductsCount >= 1
  }) === true
}